.toast {
  position: fixed;
  top: 74px;
  right: 24px;
  z-index: 300;
  background: var(--ink);
  color: white;
  padding: 13px 20px;
  border-radius: 6px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 9px;
  box-shadow: var(--shadow-lg);
  min-width: 240px;
  animation: slideIn .2s ease;
}
